import DocumentEditorController from '../entrypoints/src/admin/editor/document_editor_base';
import BootstrapNavTabs from '../entrypoints/src/admin/components/bootstrap_nav_bars';

// Document template editor: same as the contract editor, but the merge-tag set is
// dynamic — it follows the selected source (entity_type). Changing the source
// rebuilds the contract editor with that source's variables.
export default class extends DocumentEditorController {
  connect() {
    this.entityTypeSelect = this.element.querySelector('#entity-type-select');
    this.variables = this.readVariables();
    this.mountDocumentEditors();

    if (this.entityTypeSelect) {
      this.entityTypeSelect.addEventListener('change', () => {
        this.variables = this.readVariables();
        this.rebuildContractEditor(this.variables);
      });
    }

    BootstrapNavTabs.mergeCustomFeatures(this.element.querySelector('.tr-documentnav'));
  }

  disconnect() {
    this.teardownEditors();
  }

  contractGroups() {
    return this.variables;
  }

  readVariables() {
    const selected = this.entityTypeSelect && this.entityTypeSelect.selectedOptions[0];
    return selected && selected.dataset.variables ? JSON.parse(selected.dataset.variables) : [];
  }
}
